import React from "react";
import './SlideIn.css';
import { ReactComponent as RightDownload} from '../../Media/SVG/downloadSlide.svg';

export const SlideIn = ({ closeSlide, toggleForm, clickToPreviewSlideBar, submitWetransferDetails })=>{

    const pDFImg = `data:image/png;base64,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`;

    const slowMotion = {
        'right': '0',
        'transition': '2s ease-in'
    }

    return(<div className="slider" style={clickToPreviewSlideBar ? slowMotion : null}>

        <div className="slider-top">

            <div class="cls_btn" id="q_close_" onClick={closeSlide}>×</div>
            {/* jjj */}
            &#160;
            &#160;
            &#160;
        </div>

        <div className="slider-download">
            <div className="slider-left">
                <div className="title tle"> Files Ready for Download </div>
                <div className="detail">3 files, 100MB Transfer expires in 7days </div>
            </div>
            <div className="slider-right">
                {/* <button className="bbbbbnnnnn" onClick={submitWetransferDetails}>Download all</button> */}
            </div>
        </div>

        <div className="slider-list">

            <div className="card" onClick={toggleForm}>
                <img src={`${pDFImg}`} alt="p_d_f" className="portable_document_f"/>
                <div className="card-left">
                    <div className="title" style={{fontSize: '15px'}}>Purchase_Order.pdf</div>
                    <div className="size" style={{fontSize: '12px'}}>17 MB</div>
                </div>

                <div className="card-right">
                    <RightDownload className="ssvvgg"/>
                </div>
            </div>

            <div className="card" onClick={toggleForm}>
                <img src={`${pDFImg}`} alt="p_d_f" className="portable_document_f"/>
                <div className="card-left">
                        <div className="title" style={{fontSize: '15px'}}>RFQ.pdf</div>
                        <div className="size" style={{fontSize: '14px'}}>35 MB</div>
                    </div>

                    <div className="card-right">
                        <RightDownload className="ssvvgg"/>
                </div>
            </div>


            <div className="card" onClick={toggleForm}>
                <img src={`${pDFImg}`} alt="p_d_f" className="portable_document_f"/>
                <div className="card-left">
                        <div className="title" style={{fontSize: '15px'}}>Order_Specifications.pdf</div>
                        <div className="size" style={{fontSize: '14px'}}>20 MB</div>
                    </div>

                    <div className="card-right">
                        <RightDownload className="ssvvgg"/>
                </div>
            </div>

            <div className="card" onClick={toggleForm}>
                <img src={`${pDFImg}`} alt="p_d_f" className="portable_document_f"/>
                <div className="card-left">
                        <div className="title">Company_Information.pdf</div>
                        <div className="size" style={{fontSize: '14px'}}>28 MB</div>
                    </div>

                    <div className="card-right">
                        <RightDownload className="ssvvgg"/>
                </div>
            </div>



            {/* <div className="card" onClick={toggleForm}>
                <div className="card-left">
                        <div className="title">Group RFQ Form.zip</div>
                        <div className="size" style={{fontSize: '14px'}}>3.2 MB</div>
                    </div>

                    <div className="card-right">
                        <RightDownload className="ssvvgg"/>
                </div>
            </div> */}



            {/* <div className="card" onClick={toggleForm}>
                <div className="card-left">
                        <div className="title">Purchase plan.xlsx</div>
                        <div className="size" style={{fontSize: '14px'}}>17.2 MB</div>
                    </div>

                    <div className="card-right">
                        <RightDownload className="ssvvgg"/>
                </div>
            </div> */}


        </div>

    </div>)
};